export enum LockStatus {
  notLocked = 'Not Locked',
  splitting = 'Splitting',
  reverting = 'Reverting',
  savingNew = 'Saving New',
  checking = 'Checking'
}

export enum DownTimeAction {
  revert = 'revert',
  split = 'split',
  copy = 'copy',
  save = 'save'
}

export class FailedAction {
  errorMessage: string
  action: DownTimeAction
  constructor(errorMessage: string, action: DownTimeAction) {
    this.errorMessage = errorMessage
    this.action = action
  }
}
